import type { ReactNode } from 'react';
import type { ButtonProps } from '@workramp/ui';
import { Stack, Button, SubHeading } from '@workramp/ui';
import { StyledBody, StyledWrapper } from './EmptyTableState.styles';

export interface EmptyTableStateProps {
  heading: string;
  description?: string;
  className?: string;
  buttonProps?: ButtonProps & {
    text: string;
  };
  action?: ReactNode;
}

export const EmptyTableState = ({ heading, description, className, action, buttonProps }: EmptyTableStateProps) => (
  <StyledWrapper className={className}>
    <Stack size={6}>
      <Stack size={2}>
        <SubHeading level="md">{heading}</SubHeading>
        {description && <StyledBody level="md">{description}</StyledBody>}
      </Stack>
      {buttonProps && (
        <Button variant="outline" size="lg" color="secondary" {...buttonProps}>
          {buttonProps.text}
        </Button>
      )}
      {action}
    </Stack>
  </StyledWrapper>
);
